import { TwinEmployeeParametersDict } from '@teinor/erp/types/company/userInner/employeeParameter'
import { ButtonRedSecondary, ButtonSecondary } from '../../../../../../../../baseComponents/Button'
import { LittleModalCreateEditOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { ModalDeleteFilledOutside } from '../../../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'
import TwinTrans from '../../../../../../../../baseComponents/TwinTrans'
import { FormRender } from '../../../../../../../../forms/FormRenderer/types'
import { useFetchText } from '../../../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import { TwinParameters } from '@teinor/erp/types/company/config/parameter'
import useEditDeleteModal, { SetEditDeleteModalTy } from '../../../../../../../../utils/hooks/useEditDeleteModal'
import { Fragment } from 'react'

interface ConfigStripeCustomRenderProps {
    parameters: TwinParameters
    getData: () => Promise<void>
}

export const ConfigStripeCustomRender: React.FC<ConfigStripeCustomRenderProps> = ({parameters, getData}) => {
    const {openModal, setOpenModal} = useEditDeleteModal()
    let myRender = <ConfigureStripe setOpenModal={setOpenModal} />
    if (parameters?.stripeApi) {
       myRender = <ConfiguratedStripe setOpenModal={setOpenModal} />
    }
    return (
        <Fragment>
            {myRender}
            {openModal?.type === 'edit' ? <ModalStripeParametersConfig onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
            {openModal?.type === 'delete' ? <ModalDeleteStripeConfigQuote onSubmit={getData} setOpened={() => setOpenModal(null)} /> : null}
        </Fragment>
    )
}

interface ConfiguratedStripeProps {
    setOpenModal: SetEditDeleteModalTy
}

const ConfiguratedStripe: React.FC<ConfiguratedStripeProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <div className='flex gap-x-5'>
                <TwinTrans transKey={'stripeConfigured'}>Stripe configurado</TwinTrans>
            </div>
            <ButtonRedSecondary className='w-fit ml-10' type='button' onClick={() => setOpenModal({ type: 'delete', allRowData: {}})} key={'deleteStripeConfig'}><TwinTrans transKey={'deleteStripeConfig'}>Borrar configuración de stripe</TwinTrans></ButtonRedSecondary>
        </div>
    )
}

interface ConfigureStripeProps {
    setOpenModal: SetEditDeleteModalTy
}
const ConfigureStripe: React.FC<ConfigureStripeProps> = ({ setOpenModal }) => {
    return (
        <div className='gap-10 flex flex-row items-center'>
            <span><TwinTrans transKey={'stripeParametersConfig'}>Configurar parámetros de stripe</TwinTrans>:</span>
            <ButtonSecondary className='w-fit' type='button' onClick={() => setOpenModal({ type: 'edit', allRowData: {}})} key={'configStripe'}><TwinTrans transKey={'Config'}>Configurar</TwinTrans></ButtonSecondary>
        </div>
    )
}

interface ModalDeleteStripeConfigQuoteProps extends ModalEditComponentProps { }

export const ModalDeleteStripeConfigQuote: React.FC<ModalDeleteStripeConfigQuoteProps> = ({ setOpened, onSubmit }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/parameter/deleteParameters',
        data: {
            parameters: ['stripeApi']
        }
    })

    return (
        <ModalDeleteFilledOutside opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureDeleteStripeConfig', '¿Seguro que quieres borrar la configuración de stripe?'),
            subtitle: t('YouWillBeAbleToConfigItAgain', 'Podrás volver a configurarla de nuevo'),
            buttonAccept: t('delete', 'Borrar'),
        }} />
    )
}

interface ModalStripeParametersConfigProps extends ModalEditComponentProps { }

export const ModalStripeParametersConfig: React.FC<ModalStripeParametersConfigProps> = ({ setOpened, onSubmit }: ModalStripeParametersConfigProps) => {
    const { t } = useTwinTranslation()
    const fields: FormRender<TwinEmployeeParametersDict> = [
        {
            cols: 1,
            elements: [
                {
                    name: 'stripeApi',
                    label: t('stripeApi', 'Api de Stripe'),
                    component: 'InputWithLabelMargin',
                    type: 'text',
                    required: true
                },
            ]
        },
    ]
    return (
        <LittleModalCreateEditOutside className={'flex flex-col'} fields={fields} setOpened={setOpened} url={'/api/app/config/parameter/updateParameters'} translations={{
            title: t('parameters', 'Parámetros'),
            button: t('save', 'Guardar')
        }} haveButtonPermissions={true} onSubmit={onSubmit} />
    )
}